import {
  DELETE_COLUMN,
  RESET_CONDITION_MODAL,
  SET_COLUMN_NAME_VALUE,
  SET_COLUMN_SCHEME,
  SET_CONDITION_VARIABLES,
  SET_CURRENT_SORTED_VALUE,
  SET_CURSOR_POSITION,
  SET_FUNCTION_VALUE,
  SET_NODE_LIST,
  SET_SHOW_DROPDOWN,
  SET_TREE,
} from "store/constans";
import { valueTypes } from "utils/builder/ResultClasses";
import { FormulaTree } from "utils/services";
import { functionParserService } from "utils/services/functionParser.service";
import { v4 } from "uuid";

export const setConditionVariablesAC = (columns = [], types) => {
  const conditionVariables = columns.map((column) => ({
    name: column.header,
    conditionKey: column.accessorKey,
    formulaKey: column.formulaKey,
    label: column.header.split("(")[0].trim(),
    types: types[column.formulaKey],
  }));

  const dropDownVariables = conditionVariables.reduce(
    (res, variable) =>
      variable.types === valueTypes.number || variable.types === valueTypes.date || variable.types === valueTypes.customDate || variable.types === valueTypes.customNumber
        ? [
            ...res,
            {
              key: v4(),
              name: variable.name,
              label: "[" + variable.label + "]",
              formulaKey: variable.formulaKey,
              valueType:
                (variable.types === valueTypes.number || variable.types === valueTypes.customNumber) ? "number" : "date",
              nextNodeType: [FormulaTree.NODE_TYPES.Operator],
              type: FormulaTree.NODE_TYPES.Variable,
            },
          ]
        : res,
    []
  );

  return {
    type: SET_CONDITION_VARIABLES,
    payload: {
      dropdownData: {
        [FormulaTree.NODE_TYPES.Variable]: dropDownVariables,
      },
      conditionVariables,
    },
  };
};

export const setShowDropdownAC = (boolValue) => {
  return {
    type: SET_SHOW_DROPDOWN,
    payload: {
      showDropdown: boolValue,
    },
  };
};

export const setNewColumnNameValueAC = (newColumnName) => {
  return {
    type: SET_COLUMN_NAME_VALUE,
    payload: {
      newColumnName,
    },
  };
};

export const deleteColumnAC = (columnName, currentTableId) => {
  return {
    type: DELETE_COLUMN,
    payload: {
      columnName,
      currentTableId,
    },
  };
};

export const setFunctionValueAC = (functionValue) => {
  return {
    type: SET_FUNCTION_VALUE,
    payload: {
      functionValue,
    },
  };
};

export const setSortedValueAC = (currentSortedValue) => {
  return {
    type: SET_CURRENT_SORTED_VALUE,
    payload: {
      currentSortedValue,
    },
  };
};

export const setCursorPositionAC = (currentPosition) => {
  return {
    type: SET_CURSOR_POSITION,
    payload: {
      currentPosition,
    },
  };
};

export const setTreeAC = (currentTree) => {
  return {
    type: SET_TREE,
    payload: {
      currentTree,
    },
  };
};

export const setNodeListAC = (currentNodeList) => {
  return {
    type: SET_NODE_LIST,
    payload: {
      currentNodeList,
    },
  };
};

export const createColumnSchemeAC = ({
  currentTableId,
  functionValue,
  variablesForCondition,
  newColumnName,
  newColumnKey,
  currentTabId,
  currentTree,
  prevColumnKey,
  prevColumnName = null,
}) => ({
  type: SET_COLUMN_SCHEME,
  payload: {
    currentTableId,
    prevColumnName,
    prevColumnKey,
    newColumnName,
    newColumnKey,
    columnSchemes: {
      [newColumnKey]: {
        currentTree,
        newColumnName,
        newColumnKey,
        functionValue,
        columnCondition: functionValue,
        variables: variablesForCondition.map(
          ({ conditionKey, formulaKey }) => ({ conditionKey, formulaKey })
      ),
        currentTabId,
      },
    },
  },
});

export const restConditionModalAC = () => {
  return {
    type: RESET_CONDITION_MODAL,
  };
};
